import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { toasterMessages } from "../../constants/QuestionBankConstants";
import {
  apiPaths,
  get,
  postData,
} from "../../platform-components/api-integration-util";
import { Toaster } from "../../platform-components/Toaster";
import { getExamInfo } from "../../platform-components/utils/configuration";
import { getUserDetails } from "../../platform-components/utils/shared-data.service";
import "./pushapp.scss";
import moment from "moment";
import { Switch } from "@mui/material";

export default function PushApp(props) {
  console.log("push");
  let tenantId = getUserDetails()?.tenantId;
  let { id, batchid } = useParams();
  let testmodes = [
    { value: "GRAND-TEST", label: "Grant Tests" },
    { value: "MOCK-TEST", label: "Mock" },
    { value: "LIVE", label: "Live" },
    { value: "PREVIOUS-TEST", label: "Past" },
    { value: "SUBJECT", label: "Subject" },
  ];
  let testtypes = ["NEET", "FMGE"];
  let [testMode, setTestMode] = useState("");
  let [subjects, setSubjects] = useState([]);
  const [enableQuestionBatching, setEnableQuestionBatching] = useState(false);

  const { register, handleSubmit, watch, getValues, errors, setValue, reset } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
      validateCriteriaMode: "all",
    });

  useEffect(() => {
    get(apiPaths.subjects, { tenantId: tenantId, batchId: +batchid }).then(
      (res) => {
        setSubjects(res.result);
      }
    );
  }, [batchid, id, tenantId]);

  const onSaveSubmit = (formData) => {
    onSubmit(formData);
  };

  const toggleEnableQuestionBatching = (value) => {
    setEnableQuestionBatching(value);
  }

  const onSubmit = (formData) => {
    if (errors && Object.keys(errors)?.length > 0 && process && process.exit) {
      process.exit(1);
    } else {
      formPayloadForCreateExam(formData);
    }
  };
  let formPayloadForCreateExam = (formData) => {
    console.log("formData: ", formData);
    let sectionDate = new Date(`${formData.sectionDate}T00:00:00Z`);

    if (formData.testMode === "LIVE") {
      const startDateTime = moment(formData.testStartTime);
      const endDateTime = moment(formData.testEndTime);

      if (endDateTime.isBefore(startDateTime)) {
        Toaster(
          toast.TYPE.ERROR,
          "End Exam Date should be greater than Start Exam Date."
        );
        return; // Stop form submission
      }
    }

    let data = {
      active: formData.active,
      description: formData.description,
      libraryId: 3,
      libraryTestId: 0,
      liveTestEnded: true,
      locked: formData.locked === "true",
      marksCorrect: +(formData?.correctMarks || 0),
      marksInCorrect: +(formData.incorrectMarks || 0),
      // section: formData.section,
      status: "PUSH TO APP",
      subjectId: +formData.subject,
      testEndTime: formData.testEndTime,
      testMode: formData.testMode,
      testName: formData.testName,
      testStartTime: formData.testStartTime,
      testTimeInMins: +formData.totalTime,
      testType: formData.testType,
      totalMarks: +(formData.totalMarks || 0),
      questionCount: formData.totalQuestions,
      sectionDate: sectionDate,
      questionBatchCount: enableQuestionBatching && formData.questionBatchCount ? formData.questionBatchCount : null
    };

    postData(`${apiPaths.pushToApp}/${id}/${batchid}`, {
      data,
      headers: { tenantId: tenantId, userEmail: getUserDetails().email },
    })
      .then((res) => {
        if (res?.responseCode === 200) {
          Toaster(
            toast.TYPE.SUCCESS,
            toasterMessages.SUCCESS[formData?.status]
          );
          props.history.push("/app/exams/examsInfo");
        }
      })
      .catch((e) => Toaster(toast.TYPE.ERROR, toasterMessages.FAIL.DEFAULT));
  };

  return (
    <div
      class="addquestion-main"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div className="main-heading">Push To App</div>
      <div className="background-common-div">
        <div class="btn-div">
          <div style={{ float: "right" }}>
            <input
              class="btn-common"
              type="button"
              value="Push To App"
              onClick={handleSubmit(onSaveSubmit)}
            />
          </div>
        </div>

        <div className="common-div">
          <form>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div className="form-sub-div">
                  <label className="form-label">Library Name *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Library Name"
                      name="libraryName"
                      value={"Tests"}
                      disabled
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Test Name is Required"}
                    </div>
                  </div>
                </div>
                <div className="form-sub-div">
                  <label className="form-label">Test Name *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Test Name"
                      name="testName"
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Test Name is Required"}
                    </div>
                  </div>
                </div>
                <div className="form-sub-div">
                  <label className="form-label">Description *</label>
                  <div className="form-elements">
                    <textarea
                      class="form-details"
                      type="text"
                      placeholder="description"
                      name="description"
                      ref={register({
                        required: true,
                      })}
                    />
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Test Mode *</label>
                  <div class="form-elements">
                    <select
                      class="form-details"
                      name="testMode"
                      // value={watch('testMode')}
                      ref={register({
                        validate: (value) => value !== "",
                      })}
                    >
                      <option disabled value="">
                        Please Select Test Mode
                      </option>
                      {testmodes.map((ele) => (
                        <option key={ele.value} value={ele.value}>
                          {ele.label}
                        </option>
                      ))}
                    </select>
                    <div class="error-msg">
                      {" "}
                      {watch("testMode") === "" && "Test Mode is Required"}{" "}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Test Type *</label>
                  <div class="form-elements">
                    <select
                      class="form-details"
                      name="testType"
                      ref={register({
                        validate: (value) => value !== "",
                      })}
                    >
                      <option disabled value="">
                        Please Select Test Type
                      </option>
                      {testtypes.map((ele) => (
                        <option key={ele} value={ele}>
                          {ele}
                        </option>
                      ))}
                    </select>
                    <div class="error-msg">
                      {" "}
                      {watch("testType") === "" && "Test Type is Required"}{" "}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Enable Sections</label>
                  <div className="form-elements">
                    <Switch value={enableQuestionBatching} onChange={() => toggleEnableQuestionBatching(!enableQuestionBatching)}/>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Number of questions in a section</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Question Batch Count"
                      ref={register({
                        required: false,
                      })}
                      defaultValue={50}
                      name="questionBatchCount"
                      disabled={!enableQuestionBatching}
                    />
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-sub-div">
                  <label class="form-label">Subject *</label>
                  <div class="form-elements">
                    <select
                      class="form-details"
                      name="subject"
                      ref={register({
                        validate: (value) => value !== "",
                      })}
                    >
                      <option disabled value="">
                        Please Select Subject
                      </option>
                      {subjects.map((ele) => (
                        <option key={ele?.subjectId} value={ele?.subjectId}>
                          {ele?.subject}
                        </option>
                      ))}
                    </select>
                    <div class="error-msg">
                      {" "}
                      {watch("testType") === "" &&
                        watch("subject") === "" &&
                        "Subject is Required"}{" "}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Total Time (Min) *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Total Time (Min)"
                      name="totalTime"
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Total Time is Required"}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Correct Marks *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Correct Marks *"
                      name="correctMarks"
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Correct Marks is Required"}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Incorrect Marks *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Incorrect Marks"
                      name="incorrectMarks"
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Incorrect Marks is Required"}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Total Questions *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Total Questions *"
                      name="totalQuestions"
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Total Questions is Required"}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Total Marks *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Total Marks *"
                      name="totalMarks"
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Total Marks is Required"}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Section Date *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="date"
                      placeholder="Section Date"
                      name="sectionDate" // Updated the name attribute
                      ref={register({
                        required: true,
                      })}
                    />
                    <div class="error-msg">
                      {errors?.sectionDate?.type === "required" &&
                        "Section Date is Required"}
                    </div>
                  </div>
                </div>

                {watch("testMode") === "LIVE" && (
                  <div className="form-sub-div">
                    <label className="form-label">Start Exam Date *</label>
                    <div className="form-elements">
                      <input
                        className="form-details"
                        type="datetime-local"
                        placeholder="Start Exam Date"
                        name="testStartTime" // Updated the name attribute
                        ref={register({
                          required: true,
                        })}
                        onChange={(e) => {
                          const selectedDate = new Date(e.target.value);
                          const offsetInMs =
                            selectedDate.getTimezoneOffset() * 60000;
                          const utcDate = new Date(
                            selectedDate.getTime() - offsetInMs
                          );

                          // Convert UTC to IST (UTC +5:30)
                          const IST_OFFSET_IN_MS = (5 * 60 + 30) * 60000; // 5 hours 30 minutes in milliseconds
                          const istDate = new Date(
                            utcDate.getTime() + IST_OFFSET_IN_MS
                          );

                          const istDateTime = istDate
                            .toISOString()
                            .slice(0, 16);
                          setValue("testStartTime", istDateTime); // Updated the field name
                        }}
                      />
                      <div className="error-msg">
                        {errors?.testStartTime?.type === "required" &&
                          "Start Exam Date is Required"}
                      </div>
                    </div>
                  </div>
                )}

                {watch("testMode") === "LIVE" && (
                  <div className="form-sub-div">
                    <label className="form-label">End Exam Date *</label>
                    <div className="form-elements">
                      <input
                        className="form-details"
                        type="datetime-local"
                        placeholder="End Exam Date"
                        name="testEndTime" // Updated the name attribute
                        ref={register({
                          required: true,
                        })}
                        onChange={(e) => {
                          const selectedDate = new Date(e.target.value);
                          const offsetInMs =
                            selectedDate.getTimezoneOffset() * 60000;
                          const localDate = new Date(
                            selectedDate.getTime() - offsetInMs
                          );
                          const utcDateTime = localDate
                            .toISOString()
                            .slice(0, 16);
                          setValue("testEndTime", utcDateTime); // Updated the field name
                        }}
                      />
                      <div className="error-msg">
                        {errors?.testEndTime?.type === "required" &&
                          "End Exam Date is Required"}
                      </div>
                    </div>
                  </div>
                )}

                <div class="form-sub-div">
                  <label class="form-label">Active *</label>
                  <div class="form-elements">
                    <select
                      class="form-details"
                      name="active"
                      ref={register({
                        validate: (value) => value !== "",
                      })}
                    >
                      <option disabled value="">
                        Please Select Active
                      </option>
                      <option key={"true"} value={true}>
                        True
                      </option>
                      <option key={"false"} value={false}>
                        False
                      </option>
                    </select>
                    <div class="error-msg">
                      {" "}
                      {watch("active") === "" && "Active is Required"}{" "}
                    </div>
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Locked *</label>
                  <div class="form-elements">
                    <select
                      class="form-details"
                      name="locked"
                      ref={register({
                        validate: (value) => value !== "",
                      })}
                    >
                      <option disabled value="">
                        Please Select Locked
                      </option>
                      <option key={"true"} value={true}>
                        True
                      </option>
                      <option key={"false"} value={false}>
                        False
                      </option>
                    </select>
                    <div class="error-msg">
                      {" "}
                      {watch("active") === "" && "Active is Required"}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
